export enum UserProductAccessType {
	ADMIN = 'administrator',
	NONE = 'none',
}

export enum UserProductType {
	ASSET = 'info360Asset',
	INSIGHT = 'info360Insight',
	PLANT = 'info360Plant',
	MODEL = 'info360Model',
}

export enum UserProductSubdomain {
	'app' = UserProductType.INSIGHT,
	'asset' = UserProductType.ASSET,
	'model' = UserProductType.MODEL,
}

export interface UserProduct {
	name: UserProductType | 'projectAdministration';
	access: UserProductAccessType;
	url: string;
}
